import { ReactElement } from "react";
import EmptyStarImage from "../../assets/icons/icon-cool/outline/Star.svg";
import FilledStarImage from "../../assets/icons/icon-cool/filled/Star.svg";
import HalfStarImage from "../../assets/icons/icon-cool/filled/HalfFilledStar.svg"; // New image for half-filled star
import Icon from "../Icon";
import { StarContainer } from "./styles";

interface ComponentProps {
  value: number;
  totalStars?: number;
}

const Component = ({ value, totalStars = 5 }: ComponentProps) => {
  const renderStars = () => {
    const stars: ReactElement[] = [];
    const filledStars = Math.floor(value);
    const hasHalfStar = value - filledStars >= 0.5; // Check if the decimal part is 0.5 or greater
    for (let i = 1; i <= totalStars; i++) {
      let starImage;
      if (i <= filledStars) {
        starImage = FilledStarImage;
      } else if (i === filledStars + 1 && hasHalfStar) {
        starImage = HalfStarImage;
      } else {
        starImage = EmptyStarImage;
      }
      stars.push(<Icon key={i} icon={starImage} size="12px" color="red" />);
    }
    return stars;
  };

  return <StarContainer>{renderStars()}</StarContainer>;
};

export default Component;
